import Vue from 'vue'
import App from './App.vue'
import 'whatwg-fetch'
import { init as SentryInit, browserTracingIntegration } from '@sentry/vue'

import VueI18n from 'vue-i18n'
import pl from './trans/pl.json'
import es from './trans/es.json'
import en from './trans/en.json'

if (process.env.NODE_ENV === 'production') {
    SentryInit({
        Vue,
        autoSessionTracking: true,
        enableTracing: true,
        dsn: 'https://a018651a3bc6489da783ead05cdb9913@o522645.ingest.sentry.io/4504876004147200',
        integrations: [browserTracingIntegration()],
        beforeSend(event) {
          if (event.tags?.type === 'critical_error') {
            return event
          }
          return null
        },
        tracesSampleRate: 0,
        sampleRate: 0.2,
    })
}

Vue.use(VueI18n)

const i18n = new VueI18n({
    messages: { en, pl, es },
    locale: Intl.DateTimeFormat().resolvedOptions().locale.slice(0, 2) || navigator.language.slice(0,2)
})

Vue.config.productionTip = false


new Vue({
    i18n,
    render: h => h(App),
}).$mount('#app')
